import Back from 'components/Back';
import {
  Button, Card, Container, ErrorMessage,
} from 'nhsuk-react-components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useUpdateTeamRoutingPlans from 'queries/mutate/updateTeamRoutingPlans';
import { getLatestRoutingPlans } from 'utils/routingPlansUtils';
import TeamDetailsSection from '../TeamDetailsSection';
import './TeamRoutingPlans.css';
import RoutingPlansTable from './RoutingPlansTable';

function ChangeTargetsSection({
  teamId,
  initialRoutingPlans,
  fetchError,
}: {
  teamId: string;
  initialRoutingPlans: ReturnType<typeof getLatestRoutingPlans>;
  fetchError?: { message?: string } | null;
}) {
  const navigate = useNavigate();
  const [latestRoutingPlans, setLatestRoutingPlans] = useState(initialRoutingPlans);

  const { mutate: updateTeamRoutingPlans, error: updateError } = useUpdateTeamRoutingPlans();

  const handleCampaignTypeChange = (routingPlanId: string, commsTarget: string): void => {
    const nextCommsTarget = commsTarget === '' ? null : commsTarget;

    setLatestRoutingPlans((currentPlans) => currentPlans.map((plan) => (
      plan.routing_plan_id === routingPlanId
        ? { ...plan, comms_target: nextCommsTarget }
        : plan
    )));
  };

  const handleOnSaveAndContinue = (): void => {
    updateTeamRoutingPlans({
      teamId,
      routingMappings: { routing_mappings: latestRoutingPlans },
    }, {
      onSuccess: () => {
        navigate(`/admin/${teamId}/team-message-plans/change-targets/confirmation`);
      },
    });
  };

  return (
    <Container>
      <div className="nhsuk-u-margin-top-6 nhsuk-u-margin-bottom-6">
        <Back backTo={`/admin/${teamId}/team-message-plans`} />
      </div>
      <Card>
        <>
          <h1
            role="main"
            className="nhsuk-heading-l nhsuk-u-margin-top-0 nhsuk-u-margin-bottom-3"
          >
            Change targets
          </h1>
          <TeamDetailsSection teamId={teamId} />
          <RoutingPlansTable
            routingPlans={latestRoutingPlans}
            onCampaignTypeChange={handleCampaignTypeChange}
          />
        </>
      </Card>

      <ErrorMessage className="nhsuk-u-margin-top-4">
        {updateError?.message || fetchError?.message}
      </ErrorMessage>

      <div className="nhsuk-u-margin-top-4">
        <Button onClick={handleOnSaveAndContinue}>Save and continue</Button>
      </div>
    </Container>
  );
}

export default ChangeTargetsSection;
